import Vue from 'vue'
import Vuex from 'vuex'
import range from './modules/ranges'
import payFee from './modules/payFee'
import waybill from './modules/waybill'
import storeMap from './modules/storeMap'
import { getCookie } from '../util/util'

Vue.use(Vuex)

const state = {
    title: '顺丰速运', // 标题
    isLogin: !!getCookie('loginUser'),
    showHeader: true,
    showNav: false, // 显示头部的下拉菜单
    showCustomer: false, // 显示全局的客服浮窗
    showFooter: true,
    // 默认网站关键词
    metaInfo: {}
}

const getters = {}

const mutations = {
    setTitle(state, title) {
        state.title = title
    },
    setShowHeader(state, showHeader) {
        state.showHeader = showHeader
    },
    setShowNav(state, showNav) {
        state.showNav = showNav
    },
    setShowCustomer(state, showCustomer) {
        state.showCustomer = showCustomer
    },
    setShowFooter(state, showFooter) {
        state.showFooter = showFooter
    },
    changeMeta(state, metaInfo) {
        state.metaInfo = metaInfo
    }
}

const store = new Vuex.Store({
    // strict: process.env.NODE_ENV !== 'production',
    state,
    getters,
    mutations,
    modules: {
        range,
        payFee,
        waybill,
        storeMap
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js